require('./RAHireManagementPlanStep4.scss');
require('./RAHireManagementPlanStep4.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
// @constants
const {
    CHARGE_ACCOUNT_PREFIX,
    THIRD_STEP,
    FIFTH_STEP,
    CONTENT_TYPE_PDF,
} = require('constants/index');
const {
    RA_HIRE_MANAGEMENT_PLAN_OPERATION_TYPE,
} = require('../../../raConstants/index');
const {
    MULTIPLE_OPERATIONS,
    PROFILE_EDITOR_UPDATE,
} = require('constants/operationTypes');
const {
    ROBO_PRECONTRACT,
    EVIDENCE_WEALTH_ROBO_HIRING,
} = require('constants/flagBasedFeatures');

// @commons
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { recordProcess } = require('utilities/tagging');

//@constants
const { RA_CONTRACT_PDF_HEIGHT } = require('../../../raConstants/index');
const { PROPC_RA_HIRE_MANAGEMENT_PLAN } = require('utilities/tagging');

class RAHireManagementPlanStep4 extends React.Component {
    constructor(props) {
        super(props);

        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
    }

    componentDidMount() {
        const customData = {
            pageName: '/contractingRobo/step4/contractDetails',
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: 'contractingRobo',
            processStep: `step4`,
            processDetail: 'contractDetails',
            productName: 'robo',
        };
        recordProcess('', '', customData, true);
    }

    componentDidUpdate(prevProps) {
        const currCheckState = this.props.immSteps.getIn([
            FIFTH_STEP,
            'disabledCheck',
        ]);
        const prevCheckState = prevProps.immSteps.getIn([
            FIFTH_STEP,
            'disabledCheck',
        ]);
        if (currCheckState !== prevCheckState) {
            taggingEventHandled(
                PROPC_RA_HIRE_MANAGEMENT_PLAN,
                'step4_checkBoxShown',
            );
        }
    }

    handleDocumentReaded() {
        taggingEventHandled(
            PROPC_RA_HIRE_MANAGEMENT_PLAN,
            'step4_documentReadFull',
        );
        this.props.enableDisclaimerCheck();
    }
    buildPdfSection() {
        const {
            immSteps,
            onDownloadPDF,
            onPrintPDF,
            flagBasedFeatures,
            immProfile,
            immGlobalVariables,
            immHireManagementPlan,
        } = this.props;
        const disabledCheck = immSteps.getIn([FIFTH_STEP, 'disabledCheck']);
        const disclaimerChecked = immSteps.getIn([
            FIFTH_STEP,
            'disclaimerChecked',
        ]);
        const originCountry = immProfile.get('originCountry');
        const precontractURL =
            immGlobalVariables.getIn([
                'parameters',
                'contratos',
                'precontractuales_robo',
            ]) || '';
        const pdfConcat =
            immHireManagementPlan.get('pdfConcat') ||
            immHireManagementPlan.get('pdfLink');

        const pdfNewTabLink = [
            ...(flagBasedFeatures.get(ROBO_PRECONTRACT) ? (
                <OKLink to={precontractURL} key={0} target="_blank">
                    <FormattedText value="raHireManagementPlanStep4-raHireManagementPlanStep4_checkboxLabelLink1" />
                </OKLink>
            ) : (
                []
            )),
            <OKLink onClick={() => this.handleManagementPDFClick()} key={1}>
                <FormattedText value="raHireManagementPlanStep4-raHireManagementPlanStep4_checkboxLabelLink2" />
            </OKLink>,
        ];

        const boldText = (
            <FormattedTextWithComponents
                className="ra-hire-management-plan-step4__checkbox-link"
                value={`raHireManagementPlanStep4-raHireManagementPlanStep4_checkboxLabelBoldText_${originCountry}`}
                injectedComponents={pdfNewTabLink}
            />
        );
        const disclaimerText = (
            <FormattedTextWithComponents
                className="ra-hire-management-plan-step4__checkbox-text"
                id="raHireManagementPlanStep4-raHireManagementPlanStep4_checkboxLabelText"
                value="raHireManagementPlanStep4-raHireManagementPlanStep4_checkboxLabelText"
                injectedComponents={[boldText]}
            />
        );

        let checkbox;

        if (!disabledCheck) {
            checkbox = (
                <div className="ra-hire-management-plan-step4__check-box">
                    <OKCheckbox
                        idName="hire-management-disclaimer-checkbox"
                        instructionsMessage={disclaimerText}
                        onChange={e => this.handledCheckbox(e)}
                        disabled={disabledCheck}
                        value={disclaimerChecked}
                    />
                </div>
            );
        }

        return (
            <div className="ra-hire-management-plan-step4__pdf-container">
                <OKPdfViewer
                    pdfFile={pdfConcat}
                    onDocumentReaded={this.handleDocumentReaded}
                    viewerHeight={RA_CONTRACT_PDF_HEIGHT}
                    scale={1.5}
                    displayScrollButton={true}
                    onPrint={onPrintPDF}
                    onDownload={onDownloadPDF}
                    showScroll={true}
                />
                {checkbox}
            </div>
        );
    }

    handledCheckbox(e) {
        const { immProfile } = this.props;
        const originCountry = immProfile.get('originCountry');
        const poeBase = 'raHireManagementPlanStep4-raHireManagementPlanStep4_';
        const bold = formatText(
            `${poeBase}checkboxLabelBoldText_${originCountry}`,
        );
        const pdfNewTabLinkText = formatText(`${poeBase}checkboxLabelLink2`);
        const disclaimerText = formatText(`${poeBase}checkboxLabelText`);
        const termAndConditions =
            bold.split('%s')[0] + pdfNewTabLinkText + disclaimerText;

        if (e.currentTarget.checked) {
            taggingEventHandled(
                PROPC_RA_HIRE_MANAGEMENT_PLAN,
                'step4_checkboxChecked',
            );
        } else {
            taggingEventHandled(
                PROPC_RA_HIRE_MANAGEMENT_PLAN,
                'step4_checkboxUnchecked',
            );
        }
        this.props.saveTermsAndConditions(termAndConditions);
        this.props.toggleDisclaimer();
    }

    handleManagementPDFClick() {
        const documentContent = this.props.immHireManagementPlan.get('pdfLink');
        downloadAsFile(
            base64ToBlob(documentContent),
            CONTENT_TYPE_PDF,
            `Contrato GD.pdf`,
        ); // TBC: Filename
    }

    buildSignaturePattern() {
        const {
            immSteps,
            immAccounts,
            isClientEmailConfigured,
            flagBasedFeatures,
            immHireManagementPlan,
        } = this.props;
        const accountNumber = immSteps.getIn([THIRD_STEP, 'selectedAccount']);
        const originProduct = immAccounts.getIn([
            'byId',
            accountNumber,
            'product',
        ]);
        const originNumber = immAccounts.getIn([
            'byId',
            accountNumber,
            'contractNumber',
        ]);
        let operationType, operationParams;

        if (isClientEmailConfigured) {
            operationType = RA_HIRE_MANAGEMENT_PLAN_OPERATION_TYPE;
            const paramsForDms = {
                operationProcessId: immHireManagementPlan.get(
                    'operationProcessId',
                ),
                evidenceType: 'SIGN_DOCUMENT',
            };
            operationParams = {
                originAccount: `${CHARGE_ACCOUNT_PREFIX}${originProduct}${originNumber}`,
                ...(flagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING) && {
                    ...paramsForDms,
                }),
            };
        } else {
            operationType = MULTIPLE_OPERATIONS;
            operationParams = [
                {
                    serviceCode: PROFILE_EDITOR_UPDATE, // Update email
                },
                {
                    serviceCode: RA_HIRE_MANAGEMENT_PLAN_OPERATION_TYPE, // Create CGD
                    originAccount: `${CHARGE_ACCOUNT_PREFIX}${originProduct}${originNumber}`,
                },
            ];
        }

        return (
            <SignaturePattern
                customClassName="ra-hire-management-plan-step4__signature-pattern"
                operationType={operationType}
                operationParams={operationParams}
                isWealth={true}
            />
        );
    }

    render() {
        const { isSignaturePatternUnable, immGlobalVariables } = this.props;
        const GDPRlink = immGlobalVariables.getIn([
            'parameters',
            'contratos',
            'proteccion_datos',
        ]);
        const signaturePattern = isSignaturePatternUnable
            ? this.buildSignaturePattern()
            : null;
        const pdfSection = this.buildPdfSection();
        return (
            <div className="ra-hire-management-plan-step4">
                <span className="ra-hire-management-plan-step4__subtitle-contract">
                    <FormattedText value="raHireManagementPlanStep4-subtitle" />
                </span>
                {pdfSection}
                <div className="ra-hire-management-plan-step4__message">
                    <OKMessage type="informative">
                        <FormattedText
                            className="ra-hire-management-plan-step4__disclaimer-title"
                            value="raHireManagementPlanStep4-raHireManagementPlanStep4_disclaimerTitle"
                        />
                        <p>
                            <FormattedText value="raHireManagementPlanStep4-hireManagementGdprDisclaimerText" />
                            <OKLink to={GDPRlink} target="_blank">
                                <FormattedText value="raHireManagementPlanStep4-hireManagementLinkText" />
                            </OKLink>
                        </p>
                    </OKMessage>
                </div>
                {signaturePattern}
            </div>
        );
    }
}

RAHireManagementPlanStep4.propTypes = {
    enableDisclaimerCheck: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getPDFContract: PropTypes.func.isRequired,
    onDownloadPDF: PropTypes.func.isRequired,
    onPrintPDF: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSteps: PropTypes.object.isRequired,
    isSignaturePatternUnable: PropTypes.bool.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired,
    isClientEmailConfigured: PropTypes.bool.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    saveTermsAndConditions: PropTypes.func.isRequired,
};

module.exports = RAHireManagementPlanStep4;
